import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, id, name, ...props }, ref) => {
  // a11y: every field gets a stable id + name. A caller-supplied id is preserved (so existing
  // <label htmlFor> associations still match); otherwise a stable React.useId is used so no field
  // is reported "without id/name". name defaults to the id (controlled inputs don't submit by name).
  const autoId = React.useId();
  const resolvedId = id || autoId;
  return (
    <input
      type={type}
      id={resolvedId}
      name={name ?? resolvedId}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
